module.exports = __webpack_public_path__ + "static/banner-update-data-ar-a27cd68438a96dd1f65f6be18cf681ca.png";